"use client";

import usePopover from "@/src/hooks/usePopover";
import useToggle from "@/src/hooks/useToggle";
import { cn } from "@/src/shared/utils/mergeTwClasses";
import { Box, Drawer, IconButton, Popover, Typography } from "@mui/material";
import { FC } from "react";
import { Button } from "../../Button";
import { ContactActionProps } from "../lib/type";
import { ContactsList } from "./ContactsList";
import { WebShopIcon } from "@/src/components/WebShopIcon";
import {useAnalytics} from "@/src/components/pages/StepPage/components/useAnalytics";

export const ContactAction: FC<ContactActionProps> = ({
  name,
  variant,
  icon,
  contacts,
  analytics
}) => {
  const { callAnalyticEvent } = useAnalytics();
  const {
    open: openContactDrawer,
    close: closeContactDrawer,
    isToggled,
  } = useToggle({ initialState: false });
  const {
    handleClick: openContactPopover,
    anchorEl,
    handleClose: closeContactPopover,
  } = usePopover<HTMLButtonElement>();

  return (
    <>
      <Button
        // aria-describedby={"simple-popover"}
        variant={variant}
        onClick={(event) => {
            openContactPopover(event)
            analytics && callAnalyticEvent(analytics);
        }}
        size={"small"}
        className={"max-md:hidden"}
        startIcon={<WebShopIcon name={icon.name} width={16} height={16} />}
      >
        {name}
      </Button>
      <IconButton
        className={cn("hidden max-md:flex")}
        onClick={() => {
            openContactDrawer()
            analytics && callAnalyticEvent(analytics);
        }}
        aria-label={name + " contacts"}
      >
        <WebShopIcon
          name={icon.name}
          fill={icon.color ?? undefined}
          width={26}
          height={26}
        />
      </IconButton>
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={closeContactPopover}
        slotProps={{
          paper: { className: "overflow-visible bg-transparent shadow-none" },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Box
          className={
            "relative h-auto rounded-t bg-white p-2 pb-3 pt-1.5 shadow-xl box-top-triangle"
          }
        >
          <ContactsList items={contacts} />
        </Box>
      </Popover>
      <Drawer
        anchor={"bottom"}
        open={isToggled}
        className={cn("hidden max-md:flex")}
        onClose={closeContactDrawer}
      >
        <Box className={"rounded-t-2xl bg-white"}>
          <Box className={"p-4 flex-center-row"}>
            <Typography
              variant={"h1"}
              className={"block flex-grow text-center text-xl"}
            >
              {name}
            </Typography>
            <IconButton onClick={closeContactDrawer}>
              <WebShopIcon name={"close"} className="fill-blue" />
            </IconButton>
          </Box>
          <ContactsList items={contacts} />
        </Box>
      </Drawer>
    </>
  );
};
